<script>
export default {
  data() {
    return {
      layoutName: '',
      layoutEvents: null,
    };
  },

  computed: {
    layout() {
      const layoutName = this.layoutName || 'LayoutDefault';
      return () => import(`@/components/layouts/${layoutName}.vue`)
    },
  },

  methods: {
    changeLayout(layoutName) {
      if (layoutName != this.layoutName) {
          this.layoutName = layoutName;
      }
    },
    handleEvents(event) {
      this.layoutEvents = event;
    }
  },

  provide() {
    const layoutProvider = {};
    layoutProvider.changeLayout = this.changeLayout;
    layoutProvider.handleEvents = this.handleEvents;
    return { layoutProvider };
  },
}
</script>

<template>
  <component :is="layout" v-on="layoutEvents">
    <slot></slot>
  </component>
</template>


<style lang="scss" scoped>

</style>